import React from 'react';
import { FormattedMessage } from 'react-intl';

interface SearchButtonProps {
  onClick: () => void;
  disabled?: boolean;
  fullWidth?: boolean;
}

export function SearchButton({
  onClick,
  disabled = false,
  fullWidth = false,
}: SearchButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`bg-primary-600 text-primary-foreground hover:bg-primary-700 h-12 rounded px-6 text-sm font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${
        fullWidth ? 'w-full' : ''
      }`}
    >
      <FormattedMessage
        defaultMessage="Search"
        description="Search button text"
      />
    </button>
  );
}
